import axios from "axios";
import {
  API_BASE_AUTHENTICATION_URL,
  API_USER_URL,
} from "../../../util/constants";

export function createRequest(params: any) {
  if (params.state) {
    const state = require("buffer/")
      .Buffer.from(JSON.stringify(params.state))
      .toString("base64");
    return axios.request({
      method: "get",
      url: `${API_BASE_AUTHENTICATION_URL}/createRequest?state=${state}`,
    });
  } else {
    return axios.request({
      method: "get",
      url: `${API_BASE_AUTHENTICATION_URL}/createRequest`,
    });
  }
}

export function getUser() {
  return axios.request({
    method: "get",
    url: `${API_USER_URL}`,
  });
}

export function logout() {
  return axios.request({
    method: "get",
    withCredentials: true,
    url: `${API_BASE_AUTHENTICATION_URL}/logout`,
  });
}

export function createLogoutRequest() {
  return axios.request({
    method: "get",
    withCredentials: true,
    url: `${API_BASE_AUTHENTICATION_URL}/createLogoutRequest`,
  });
}
